/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bell-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M22.56 16.56l-1.324-1.324a.999.999 0 0 1-.283-.566l-1.034-7.235a7.495 7.495 0 0 0-14.838 0L4.047 14.67a.999.999 0 0 1-.283.566L2.44 16.56A1.5 1.5 0 0 0 2 17.62v.879A1.5 1.5 0 0 0 3.5 20h18a1.5 1.5 0 0 0 1.5-1.5v-.879a1.5 1.5 0 0 0-.44-1.06zM14.985 21H9a3.542 3.542 0 0 0 7 0h-1.015z"/>'
  }
})
